export enum NotificationType {
    EMAIL_WATCHER_NOTIFICATION = 'emailWatcherNotification',
    EMAIL_REVIEWER_NOTIFICATION = 'emailReviewerNotification',
    EMAIL_APPROVER_NOTIFICATION = 'emailApproverNotification',
    SLACK_REVIEWER_NOTIFICATION = 'slackReviewerNotification',
    SLACK_APPROVER_NOTIFICATION = 'slackApproverNotification',
    EVENT_UPDATE_SUBSCRIPTION = 'emailEventUpdateSubscription',
}

export type TreeItem = {
    id: string,
    caption: string,
    children?: TreeItem[],
    expanded?: boolean,
    disabled?: boolean,
};
